import { useSelector } from "react-redux";
import { selectCurrentOrganization } from "../app/slices/UserSlice";
import { selectToken } from "../app/slices/AuthenticationSlice";
import { useDispatch } from "react-redux";
import { setIsLoading } from "../app/slices/GlobalSlice";
import LocalizedLanguageDTO from "../dto/LocalizedLanguageDTO";
import { selectTrainingLocalizationState } from "../app/slices/TrainingLocalizationSlice";
import { UseSerializeLocalization } from "./SerializeLocalizationHook";
import { useSaveTraining } from "./SaveTrainingHook";
import { TrainingService } from "../services/TrainingService";
import {
  CreatorNetworkMessage,
  CreatorNetworkMessageType,
} from "../models/CreatorNetworkMessage";
import { stripDisabledInteractions } from "../helpers/DisabledInteractionsHelper";
import { Training } from "../models/Training";
import { WebSocketService } from "../services/WebSocketService";

export default function useSendToUnity() {
  const orgId = useSelector(selectCurrentOrganization)?.id;
  const token = useSelector(selectToken);
  const locState = useSelector(selectTrainingLocalizationState);
  const dispatch = useDispatch();
  const {
    getSerializedTraining,
    getSerializedTrainingSingleTake,
    getSerializedTrainingFromCurrentTake,
  } = useSaveTraining();
  const { serializeLanguageForTesting } = UseSerializeLocalization();

  const testCurrentProject = async () => {
    if (!orgId) return;
    dispatch(setIsLoading(true));
    var localization: LocalizedLanguageDTO[] = [];
    for (var i = 0; i < locState.localizedLanguages.length; i++) {
      localization.push(
        serializeLanguageForTesting(locState.localizedLanguages[i].shortcode)
      );
    }

    const training = stripDisabledInteractions(getSerializedTraining());
    const data = {
      takes: training,
      localization: localization,
    };

    // for testing transpiler
    console.log({
      takes: JSON.stringify(training),
      localizations: localization,
    });

    //console.log(JSON.stringify(data));
    //console.log(data);

    var testableEditorData: string = await TrainingService.GetTrainingTestData(
      orgId,
      token,
      data
    );

    if (!testableEditorData) return;
    // we do this and then we send to WS
    sendTestDataToUnity(testableEditorData);
    dispatch(setIsLoading(false));
  };

  const testCurrentBubble = async () => {
    if (!orgId) return;
    dispatch(setIsLoading(true));
    var localization: LocalizedLanguageDTO[] = [];
    for (var i = 0; i < locState.localizedLanguages.length; i++) {
      localization.push(
        serializeLanguageForTesting(locState.localizedLanguages[i].shortcode)
      );
    }

    const training: Training = stripDisabledInteractions(
      getSerializedTrainingSingleTake()
    );
    const data = {
      takes: training,
      localization: localization,
    };

    var testableEditorData: string = await TrainingService.GetTrainingTestData(
      orgId,
      token,
      data
    );

    dispatch(setIsLoading(false));
    sendTestDataToUnity(testableEditorData);
  };

  const testFromCurrentTake = async () => {
    if (!orgId) return;
    dispatch(setIsLoading(true));
    var localization: LocalizedLanguageDTO[] = [];
    for (var i = 0; i < locState.localizedLanguages.length; i++) {
      localization.push(
        serializeLanguageForTesting(locState.localizedLanguages[i].shortcode)
      );
    }

    const training: Training = stripDisabledInteractions(
      getSerializedTrainingFromCurrentTake()
    );
    const data = {
      takes: training,
      localization: localization,
    };

    var testableEditorData: string = await TrainingService.GetTrainingTestData(
      orgId,
      token,
      data
    );
    //console.log(testableEditorData);

    dispatch(setIsLoading(false));
    sendTestDataToUnity(testableEditorData);
  };

  const sendTestDataToUnity = async (testData: string) => {
    if (!WebSocketService.isConnected()) return;
    const message: CreatorNetworkMessage = {
      messageType: CreatorNetworkMessageType.PlayableScenario,
      data: testData,
    };

    WebSocketService.sendMessage(JSON.stringify(message));
  };

  return { testCurrentProject, testCurrentBubble, testFromCurrentTake };
}
